import { PropertyAPI } from "../../axios";

export const actions = {

    // Property Transfer
    GetPropertyTransferSingle(context, data){
        return PropertyAPI.get(`PropertyTransfer/${data}`);
    },
    GetPropertyTransferPostedByEmployee(context, data){
        return PropertyAPI.get(`PropertyTransfer/Posted/${data}`);
    },
    GetPropertyTransferDraftByEmployee(context, data){
        return PropertyAPI.get(`PropertyTransfer/Draft/${data}`);
    },
    GetPropertyTransferApprovedtByEmployee(context, data){
        return PropertyAPI.get(`PropertyTransfer/Approved/My/${data}`);
    },
    GetPropertyTransferPostedByCampus(context, data){
        return PropertyAPI.get(`PropertyTransfer/Posted/Campus/${data}`);
    },
    GetPropertyTransferApprovedtByCampus(context, data){
        return PropertyAPI.get(`PropertyTransfer/Approved/Campus/${data}`);
    },
    CreatePropertyTransfer(context, data){
        return PropertyAPI.post(`PropertyTransfer/Create/${data.campusId}`, data);
    },
    PostPropertyTransfer(context, data){
        return PropertyAPI.post(`PropertyTransfer/Post/${data}`);
    },
    ApprovePropertyTransfer(context, data){
        return PropertyAPI.post(`PropertyTransfer/Approve/${data}`);
    },
    ReturnPropertyTransfer(context, data){
        return PropertyAPI.post(`PropertyTransfer/Return/${data}`);
    },
    UpdatePropertyTransfer(context, data){
        return PropertyAPI.put(`PropertyTransfer/Update/${data.id}`, data);
    },
    DeletePropertyTransfer(context, data){
        return PropertyAPI.delete(`PropertyTransfer/Delete/${data}`);
    },
    GetPendingPropertyTransfer(context, data){
        return PropertyAPI.get(`PropertyTransfer/Pending/Campus/${data}`);
    }
}